module.exports = __webpack_public_path__ + "img/2.fd462cfc.jpg";